import { useNavigate, useParams } from 'react-router-dom';

import { DocumentDetailModal } from './DocumentDetailModal';

/**
 * Full-screen route for viewing a document_reference — the document analog of
 * `/note/:noteId`. Migrated clinical notes (stored as `clinical_note` docrefs)
 * open here. Reuses DocumentDetailModal's PDF viewer; closing returns to the
 * previous page, or the document list when opened directly.
 */
export function DocumentRoute() {
  const { documentId } = useParams<{ documentId: string }>();
  const navigate = useNavigate();

  const handleClose = (): void => {
    // A directly opened document has no earlier app route. Browser history can
    // still include about:blank or iframe entries, so use the router's index.
    const historyState: unknown = window.history.state;
    const hasPreviousRoute =
      historyState !== null &&
      typeof historyState === 'object' &&
      'idx' in historyState &&
      typeof historyState.idx === 'number' &&
      historyState.idx > 0;
    if (hasPreviousRoute) navigate(-1);
    else navigate('/documents', { replace: true });
  };

  return <DocumentDetailModal open documentId={documentId ?? null} onClose={handleClose} />;
}
